var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForumTwoTone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F9E9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 25V11.05C10 10.8167 10.1083 10.5833 10.325 10.35C10.5417 10.1167 10.7667 10 11 10H23.975C24.225 10 24.4583 10.1125 24.675 10.3375C24.8917 10.5625 25 10.8 25 11.05V19.95C25 20.1833 24.8917 20.4167 24.675 20.65C24.4583 20.8833 24.225 21 23.975 21H14L10 25ZM15.025 26C14.7917 26 14.5625 25.8833 14.3375 25.65C14.1125 25.4167 14 25.1833 14 24.95V22.5H26.5V14H29C29.2333 14 29.4583 14.1167 29.675 14.35C29.8917 14.5833 30 14.825 30 15.075V29.975L26.025 26H15.025ZM23.5 11.5H11.5V21.375L13.375 19.5H23.5V11.5Z",
    fill: "#7E0386"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForumTwoTone);
export default __webpack_public_path__ + "static/media/forumTwoTone.fb5c87468826f542c6e6471cacda8d90.svg";
export { ForwardRef as ReactComponent };